export default __webpack_public_path__ + "static/media/TubeStandSMWide.f2d2e6d0.svg";